import * as React from 'react';
import Office from '../../../models/Office';
import FormButton from 'src/components/controls/forms/redesign/FormButton';
import PropertyUtil from 'src/util/PropertyUtil';
import { RouteComponentProps } from 'react-router-dom';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

interface IAdminOfficePageStateProps {
    isLoading: boolean;
    offices: Array<Office> | undefined;
    editOffice: boolean;
    addOffice: boolean;
    selectedOfficeIndex: number;
    isLoggedIn: boolean;
}

export interface IAdminOfficePageDispatchProps {
    getOffices: () => void;
    deleteOffice: (id: number) => void;
    navigate: (path: string) => void;
}

type IAdminOfficePageProps = RouteComponentProps<{}> & IAdminOfficePageStateProps & IAdminOfficePageDispatchProps;
class AdminOfficePage extends React.Component<IAdminOfficePageProps, IAdminOfficePageStateProps> {
    constructor(props: IAdminOfficePageProps) {
        super(props);

        this.state = {
            editOffice: false,
            addOffice: false,
            selectedOfficeIndex: undefined,
            isLoading: true,
            isLoggedIn: false,
            offices: new Array<Office>(),
        };
    }

    componentDidMount() {
        this.props.getOffices();
    }

    editOffice = (index: number) => {
        this.props.navigate(`/admin/edit-office/${index}`);
    };

    addOffice = () => {
        this.props.navigate(`/admin/create-office`);
    };

    delete = (id: number) => {
        this.props.deleteOffice(id);
    };

    displayExistingOffices = () => {
        const offices = PropertyUtil.SafeGet(() => this.props.offices);
        if (offices) {
            return offices.map((o: Office) => {
                return (
                    <div key={o.id} className="card">
                        <div className="lh-fifth-width">{o.name}</div>
                        <div className="lh-three-fifths-width">
                            <div>{o.address.addressLine1}</div>
                            <div>{o.address.addressLine2}</div>
                            <div>{o.address.city + ' ' + o.address.state.abbreviation + ' ' + o.address.zipCode}</div>
                        </div>
                        <div className="lh-fifth-width right-align mb-1">
                            <FormButton text="Edit" onClick={() => this.editOffice(o.id)} size="small" className="mr-1" />
                            <FormButton text="Delete" onClick={() => this.delete(o.id)} size="small" intent="danger" />
                        </div>
                    </div>
                );
            });
        } else {
            return <div>No offices for project</div>;
        }
    };

    public render() {
        if (!this.props.isLoading) {
            return (
                <>
                    {!this.state.editOffice && !this.state.addOffice && (
                        <>
                            <div className="card-list">
                                <div className="card">
                                    <div className="label lh-fifth-width">Name</div>
                                    <div className="label lh-three-fifths-width">Address</div>
                                    <div className="label lh-fifth-width right-align" />
                                </div>
                                {this.displayExistingOffices()}
                            </div>

                            <div>
                                <FormButton text="Add Office" intent="primary" onClick={this.addOffice} />
                            </div>
                        </>
                    )}
                </>
            );
        } else {
            return <></>;
        }
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoading: selectors.office.isLoadingOffices(state),
    offices: selectors.office.offices(state),
});

const mapDispatchToProps: IAdminOfficePageDispatchProps = {
    getOffices: () => actions.office.getOffices(),
    deleteOffice: (id: number) => actions.office.deleteOffice(id),
    navigate: (path: string) => push(path),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminOfficePage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminOfficesPage.tsx